import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import ChevronRight from "@assets/svg/ChevronRight";
import Text from "@components/CustomText";
import colors from "@constants/color";
import getWalletIcon from "./WalletIcon";

type GullakProps = {
  summary: {
    value: string;
    value_txt: string;
    title: string;
    cta_txt: string;
    key: string;
  };
  onPress: () => void;
};

const GullakCard: React.FC<GullakProps> = ({ summary, onPress = () => {} }) => {
  return (
    <TouchableOpacity
      style={styles.gullakContainer}
      onPress={onPress}
      activeOpacity={0.7}
    >
      {getWalletIcon(summary?.key)}
      <View
        style={styles.gullakTextContainer}
      >
        <Text style={styles.gullakAmount}>{summary?.value_txt}</Text>
        <Text variant="body_text_3" style={styles.gullakLabel}>
          {summary?.title}
        </Text>
      </View>
      <View
        style={styles.withdrawButton}
      >
        <Text variant="caption_2" style={styles.withdrawText}>
          {summary?.cta_txt}
        </Text>
        <ChevronRight pathFill={colors.darkGrey} style={styles.chevronIcon} />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  gullakContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    paddingHorizontal: 16,
    backgroundColor: colors.white,
    borderRadius: 8,
    elevation: 1,
    marginHorizontal: 16,
  },
  gullakTextContainer: {
    flex: 1,
    marginLeft: 12,
  },
  gullakAmount: {
    fontSize: 30,
    fontWeight: "bold",
    color: colors.mediumBlack,
    lineHeight: 35,
  },
  gullakLabel: {
    fontSize: 14,
    color: colors.black06,
    top: 4,
  },
  withdrawButton: {
    position: "absolute",
    bottom: 10,
    right: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  withdrawText: {
    color: colors.darkGrey,
    marginRight: 4,
  },
  chevronIcon: {
    height: 12,
    width: 12,
  },
});

export default GullakCard;
